export function isDefined<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
}

export function isEmpty<T>(array: T[] | undefined): boolean {
    return !isNotEmpty(array);
}

export function isNotEmpty<T>(array: T[] | undefined): boolean {
    return !!array?.length;
}

export function everyOtherItem<T>(array: T[], isEven: boolean): T[] {
    if (!array || !array.length) {
        return [];
    }
    return array.filter((item, index) => {
        if (!isEven) {
            return index % 2 !== 0;
        }
        return index % 2 === 0;
    });
}

export function chunk<T>(array: T[], chunkSize: number): T[][] {
    const results: T[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        const chunk = array.slice(i, i + chunkSize);
        results.push(chunk);
    }
    return results;
}

export function flatten2DArray<T>(array: T[][]): T[] {
    return array.reduce((result, currArray) => result.concat(currArray || []), []);
}

type IntersectionComparator<T> = (left: T, right: T) => boolean;

export function intersection<T>(
    left: T[],
    right: T[],
    comparator: IntersectionComparator<T> = defaultComparator,
): T[] {
    return left.filter((l) => right.some((r) => comparator(l, r)));
}

function defaultComparator<T>(left: T, right: T): boolean {
    return left === right;
}
